import type { WorkReview } from "@/types/anime";

export default function ReviewList({ reviews }: { reviews: WorkReview[] }) {
  if (reviews.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {reviews.map((review) => (
        <div key={review.user} className="rounded-lg border border-background-200 bg-background-50 p-5">
          <div className="flex items-center gap-3">
            <span className="h-10 w-10 overflow-hidden rounded-full bg-background-100">
              <img src={review.avatar} alt={`${review.user} 头像`} className="h-full w-full object-cover" />
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{review.user}</p>
              <div className="mt-0.5 flex items-center gap-0.5 text-accent-500">
                {Array.from({ length: 5 }).map((_, index) => (
                  <i
                    key={index}
                    className={index < review.rating ? "ri-star-fill text-xs" : "ri-star-line text-xs"}
                  />
                ))}
              </div>
            </div>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{review.comment}</p>
        </div>
      ))}
    </div>
  );
}